export default __webpack_public_path__ + "static/media/oscer-pres-itch.a212350a.svg";